import $ from 'jquery';


const toggler = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: '',
        targetSelector: null,
        outsideToggle: true
    }, options);


    m = toggler.markup;


    internal = {
        $e: o.$e || $(o.selector),
        targetSelector: o.targetSelector,
        outsideToggle: o.outsideToggle,
        active: false
    };


    elements = {
        doc: $(document),
        target: $(internal.targetSelector)
    };


    fn = {
        init () {
            if (elements.target.length > 0) {
                internal.$e.on('click', handlers.togglerClick);
            }
        },

        activate () {
            internal.$e.addClass(m.ACTIVE);
            elements.target.addClass(m.ACTIVE);
            internal.active = true;

            if (internal.outsideToggle) {
                setTimeout(() => {
                    elements.doc.on('click.toggler', handlers.docClick);
                });
            }
        },

        deactivate () {
            internal.$e.removeClass(m.ACTIVE);
            elements.target.removeClass(m.ACTIVE);
            internal.active = false;

            if (internal.outsideToggle) {
                elements.doc.off('click.toggler');
            }
        }
    };


    handlers = {
        togglerClick (e) {
            if (internal.active) {
                fn.deactivate();
            } else {
                fn.activate();
            }
            e.preventDefault();
        },

        docClick (e) {
            if ($(e.target).closest(internal.targetSelector).length === 0) {
                fn.deactivate();
                e.preventDefault();
            }
        }
    };


    fn.init();
};


toggler.markup = {
    // dom selector
    CONTAINER: 'toggler',

    // states
    ACTIVE: 'state-active'
};


export default toggler;



// WEBPACK FOOTER //
// ./assets/js/components/toggler.js